(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["data-provider"]) return;
  try {
    
  console.log(1)
  window.catalog = {
    products: [
    
    ]
  };
  
  console.log(2)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-snippet"]) return;
  try {
    
  
  $(document).ready(function () {
    const _urlParams = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
  
    if(_urlParams.judgeme_follow_up_token && _urlParams.judgeme_follow_up_token != '') { 
      function closePopup() {
        popupRoot.css('display', 'none');
        history.replaceState('ajax','', window.location.origin + window.location.pathname);
      }

      var popupRoot = $('.thankyou-review-popup');
      popupRoot.css('display', 'flex');

      popupRoot.find('.thankyou-review-popup--close-button').click(closePopup);
      // popupRoot.click(closePopup);
    }
  });


  } catch(e) { console.error(e); }
})();
})();
